GatiServerGame = function () {
  var base = new GatiServer();
  GatiServer.call(this, base);
  this.inFS = false;
  this.fsIndex = 0;
  this.fsWinnings = 0;
  this.numFsRemaining = 0;
  this.fsCount = 0;
  this.addGameConfigToQueueBase = this.addGameConfigToQueue;
  this.addGameConfigToQueue = this.addGameConfigToQueueDerived;

  this.addRecoveryToQueueBase = this.addRecoveryToQueue;
  this.addRecoveryToQueue = this.addRecoveryToQueueDerived;
  this.restorePreviousWagersBase = this.restorePreviousWagers;
  this.restorePreviousWagers = this.restorePreviousWagersDerived;

  this.startGameBase = this.startGame;
  this.startGame = this.startGameDerived;
  this._inEncore = false;
  this._inBuyABonus = false;
  this._rtp = 0;
  this._baseGameWinnings = 0;
  this._localRngSeed = -1;

  this._baseOutcome = {
    spins: [],
  };

  // this.loadLanguageFiles = undefined; // delete me when translations are ready
};

GatiServerGame.prototype = Object.create(GatiServer.prototype);

GatiServerGame.prototype.initServer = function (cb) {
  this.init(
    function () {
      cb();
    },
    function () {},
    'ReflexGaming',
    'LEFT_TOP',
    [],
    'TOP_LEFT'
  );
};

GatiServerGame.prototype.getSupplierForceName = function () {
  return 'gati';
};
GatiServer.prototype.checkForAndHandlePrepaids = function (prepaidObj) {
  if (prepaidObj && prepaidObj.amount) {
    this.changeStake(prepaidObj.amount * 100);
    messageBus.post('prepaid:StakeChange', prepaidObj.amount * 100);
    messageBus.post('common:PromotionStarted');
    messageBus.post('platform:setButtonState', {
      buttonName: 'Stake',
      enabled: false,
    });

    this._isPrePaidGame = true;
  } else if (this._isPrePaidGame) {
    this._isPrePaidGame = false;
    messageBus.post('common:PromotionEnded', {
      replayGame: this._inRewatchMode || this._inReplayMode,
    });
    messageBus.post('platform:setButtonState', {
      buttonName: 'Stake',
      enabled: true,
    });
  }
};

GatiServerGame.prototype.updateCurrentStake = function (newStake) {
  if (this._stake != newStake) {
    let isStakeLower = newStake < this._stake;
    this._stake = newStake;
    this._slotGame.getGameEventsEmitter().totalBetChanged(this._stake / 100);

    let sc = resourceManager.getController('stakeController');
    if (sc.isMaxStake() && !this._inReplayMode && !this._inRewatchMode && !this._isPrePaidGame && !isStakeLower) {
      this._slotGame.uiComponents().clickActionHandler();
    }
  }
};

GatiServerGame.prototype.setBPL = function (bpl) {
  let baseStake = this._numLines * bpl;
  let newStake = baseStake;
  if (gameData.encoreEnabled) {
    newStake *= 1.5;
  }

  this.updateCurrentStake(newStake);
};

GatiServerGame.prototype.restorePreviousWagersDerived = function () {
  let res = this.restorePreviousWagersBase();

  if (
    this._previousWagers &&
    this._previousWagers.data &&
    this._previousWagers.data.length > 0 &&
    this._previousWagers.data[0].bets &&
    this._previousWagers.data[0].bets.length > 0 &&
    this._previousWagers.data[0].bets[0].betdata.cmd === 'LUCKYBET_BUY'
  ) {
    // res.baseStake *= 10; // coin for lucky bet is 10x bigger
    this.setDefaultBet(res.baseStake);
  }
  return res;
};

GatiServerGame.prototype.addGameConfigToQueueDerived = function (loadData) {
  if (this._inReplayMode === true && this._slotGame.getWagerHelper().getPrepaidInfo().isPrepaid === true) {
    this.prepaidInitialBalance = parseFloat(loadData.wagers.data[0].bets[0].betdata.initialBalance) * 100;
    this.prepaidResultBalance = parseFloat(loadData.wagers.data[0].bets[0].eventdata.resultBalance) * 100;
  }
  this.addGameConfigToQueueBase(loadData);
  let message = this._messageQueue[0];
  message.buyBonusCost = 100;
  gdk.addConfigValue('AllowBuyBonus', message.slotConfig.gameModes['BONUS_BUY'] ? true : false);

  gameData.license = loadData.customParameters.license;

  message.maxExposure = loadData.settings.slotConfig.MaxExposure;

  message.slotConfig.coins = 10; // purely paytable

  gameData.recoveryStake = undefined;
  if (loadData.wagers.data.length) {
    let betData = loadData.wagers.data[0].bets[0].betdata;
    let stake = Number(betData.coin * 1000);
    gameData.recoveryStake = stake;
    if (betData.cmd === 'LUCKYBET_BUY') {
      gameData.recoveryStake *= 1.5;
    }
  }

  this._rtp = message.slotConfig.rtp;

  this._gambleChances = [];
  this._gambleChances.push(message.slotConfig.gambleConfig.x3Chance / message.slotConfig.gambleConfig.x3Denominator);
  this._gambleChances.push(message.slotConfig.gambleConfig.x4Chance / message.slotConfig.gambleConfig.x4Denominator);
  this._gambleChances.push(-1); // should never be used but stops array failing

  message.gambleChances7To10 = this._gambleChances[0];
  message.gambleChances10To13 = this._gambleChances[1];

  let stopDistances2 = [0, 2, 5, 8, 11];
  let stopDistances2and5 = [3, 7, 11, 15, 19];
  let stopDistances3 = [11, 15, 19, 23, 27];
  let stopDistances5 = [24, 32, 40, 48, 56];
  switch (this._license) {
    case 'uk':
      message.stopDistances = stopDistances2and5;
      break;
    case 'UKGCRtsTest':
      message.stopDistances = stopDistances2and5;
      break;
    case 'bgc':
      message.stopDistances = stopDistances2and5;
      break;
    case 'es':
      message.stopDistances = stopDistances3;
      break;
    case 'se':
      message.stopDistances = stopDistances3;
      break;
    case 'dk':
      message.stopDistances = stopDistances3;
      break;
    case 'cz':
      message.stopDistances = stopDistances2and5;
      break;
    case 'co':
      message.stopDistances = stopDistances3;
      break;
    case 'agcc':
      message.stopDistances = stopDistances2and5;
      break;
    case 'de':
      message.stopDistances = stopDistances5;
      break;
    default:
      message.stopDistances = stopDistances2;
      break;
  }
};

GatiServerGame.prototype.addRecoveryToQueueDerived = function () {
  for (let i = 0; i < this._latestEngineReponse.wager.bets.length; ++i) {
    let bet = this._latestEngineReponse.wager.bets[i];
    if (bet.betdata.cmd === 'LUCKYBET_BUY') {
      this._inEncore = true;
      this._meta = {
        name: 'encore',
        value: true,
      };
      break;
    } else if (bet.betdata.cmd === 'BONUS_BUY') {
      this._inBuyABonus = true;
      this._meta = {
        name: 'buyABonus',
        value: true,
      };
      break;
    }
  }
  this.addRecoveryToQueueBase();
};

GatiServerGame.prototype.startGameDerived = function (stakeData, cb) {
  this._inEncore = stakeData.metaData.encore;
  this._inBuyABonus = stakeData.metaData.buyABonus;

  this.startGameBase(stakeData, cb);
};

GatiServerGame.prototype.addMetaDataToSpinRequest = function (request) {
  this._coinValue = 10;
  let stakeController = resourceManager.getController('stakeController');
  let baseStake = stakeController.getBaseStake('default') / 100;

  request.coin = request.amount / this._coinValue;
  request.coins = this._coinValue;

  if (this._inEncore) {
    this._coinValue = 10; // has to be whole number
    request.amount = baseStake * 1.5;
    request.coin = baseStake / this._coinValue;
    request.cmd = 'LUCKYBET_BUY';
  } else if (this._inBuyABonus) {
    baseStake = stakeController.getBaseStake('BONUS_BUY') / 100;
    request.amount = baseStake * 100;
    request.coin = baseStake / this._coinValue;
    request.cmd = 'BONUS_BUY';
  }
};

GatiServerGame.prototype.getSpinDataNormal = function (data) {
  let spinEvent = data.respins[0].spinEvent;
  if (!this.validateResponse(spinEvent)) return;
  this.addSpinDataToQueue(spinEvent);

  let totalWinInBase = 0;
  for (let i = 0; i < data.respins.length - 1; ++i) {
    totalWinInBase += data.respins[i].winAmount;

    // we need to add the left to right wins and right to left wins into the same event
    let rightToLeftWinningLineEvent = JSON.parse(JSON.stringify(data.respins[i].rightToLeftWinningLineEvent));
    let allWinningLineEvent = JSON.parse(JSON.stringify(data.respins[i].winningLineEvent));

    // add in any right to left winnings to the total - not used at present but
    // added in for completeness
    allWinningLineEvent.totalLineWinnings += rightToLeftWinningLineEvent.totalLineWinnings;

    for (let wl = 0; wl < rightToLeftWinningLineEvent.winningLines.length; wl++) {
      allWinningLineEvent.winningLines.push(rightToLeftWinningLineEvent.winningLines[wl]);
    }

    // set up the pops and drops
    let winningCoords = data.respins[i].winningCoords;
    if (allWinningLineEvent.winningLines.length > 0) {
      this.addPopsToQueue(
        allWinningLineEvent,
        data.respins[i].multiplier,
        data.respins[i].winAmountBeforeMultiplier,
        data.respins[i].winAmount
      );
      this.addDropsToQueue(
        data.respins[i + 1].spinEvent.resultsPanel.reelList,
        data.respins[i + 1].wildCoords,
        winningCoords
      );
    }

    // if we have a multiplier boost do it before next wins are evaluated
    // this also handles the case where the last spin has boost multipliers
    if (data.respins[i + 1].multiplierPreWinBoost > 0) {
      let message = {};
      message.type = 'Game:boostMulti';
      message.multiSteps = data.respins[i + 1].multiplierPreWinBoost;
      this._messageQueue.push(message);
    }
  }
  this.addPopDropsOverToQueue(totalWinInBase);
  return totalWinInBase;
};

GatiServerGame.prototype.addMultiplerToQueue = function (multiplier) {
  var message = {};
  message.type = 'Game:MultiplierEvent';
  message.currentMultiplier = multiplier; //1 + Math.floor(this.gameOutcome.numSpins / message.totalSteps);
  message.nextMultiplier = multiplier * 2; //message.currentMultiplier + 1;
  this._messageQueue.push(message);
};

GatiServer.prototype.addSpinDataToQueue = function (event) {
  var message = {};
  message.type = 'spinner:SpinEvent';

  message.panelMultiplier = 1;
  message.lines = event.lines;
  message.baseBet = this._stake;
  message.betMultiplier = 1;
  message.totalWinnings = event.totalWinnings;
  message.resultPanel = {};
  message.resultPanel.reels = 5;
  message.isPrePaidGame = this._isPrePaidGame;
  message.resultPanel.rectangular = true;
  if (event.jackpotGame !== undefined && event.jackpotGame === true) {
    message.jackpotGame = true;
  }

  message.resultPanel.reelList = event.resultsPanel.reelList;
  message.resultPanel.symbolsAbove = event.resultsPanel.symbolsAbove;
  message.resultPanel.symbolsBelow = event.resultsPanel.symbolsBelow;

  if (this._localRngSeed !== -1) {
    message.localRng = this._localRngSeed;
  }

  this._messageQueue.push(message);
};

GatiServerGame.prototype.getSpinDataFS = function (cb) {
  let data = this.freeSpins[this.fsCount++];
  --this.numFsRemaining;

  this.addMultiplerToQueue(data.respins[0].multiplier);

  let spinEvent = data.respins[0].spinEvent;
  this.addSpinDataToQueue(spinEvent);

  let spinWin = 0;
  for (let i = 0; i < data.respins.length - 1; ++i) {
    spinWin += data.respins[i].winAmount;

    // we need to add the left to right wins and right to left wins into the same event
    let rightToLeftWinningLineEvent = JSON.parse(JSON.stringify(data.respins[i].rightToLeftWinningLineEvent));
    let allWinningLineEvent = JSON.parse(JSON.stringify(data.respins[i].winningLineEvent));
    // add in any right to left winnings to the total - not used at present but
    // added in for completeness
    allWinningLineEvent.totalLineWinnings += rightToLeftWinningLineEvent.totalLineWinnings;

    for (let wl = 0; wl < rightToLeftWinningLineEvent.winningLines.length; wl++) {
      allWinningLineEvent.winningLines.push(rightToLeftWinningLineEvent.winningLines[wl]);
    }

    // set up the pops and drops
    let winningCoords = data.respins[i].winningCoords;
    //let winningLineEvent = data.respins[i].winningLineEvent;
    if (allWinningLineEvent.winningLines.length > 0) {
      this.addPopsToQueue(
        allWinningLineEvent,
        data.respins[i].multiplier,
        data.respins[i].winAmountBeforeMultiplier,
        data.respins[i].winAmount
      );
      this.addDropsToQueue(
        data.respins[i + 1].spinEvent.resultsPanel.reelList,
        data.respins[i + 1].wildCoords,
        winningCoords
      );
    }

    let allowMultiBoost = true;
    // if multi boosting on the last respin of the last spin of a set of freespins and there is no win
    // don't show the multi boost - replace it with a wild
    if (this.numFsRemaining === 0 && i >= data.respins.length - 2 && data.respins[i + 1].winAmount === 0) {
      // there should only be one multiboost
      if (data.respins[i + 1].wildCoords[0].kind === 1) {
        data.respins[i + 1].wildCoords[0].kind = 0;
        // change symbol in spin event - if no win then the wild being replaced won't create a new win
        let reelData =
          data.respins[i + 1].spinEvent.resultsPanel.reelList[data.respins[i + 1].wildCoords[0].coord.reel];
        reelData.symbols[data.respins[i + 1].wildCoords[0].coord.offset].value = 8; // wild id
        allowMultiBoost = false;
      }
    }

    // if we have a multiplier boost do it before next wins are evaluated
    // this also handles the case where the last spin has boost multipliers
    if (allowMultiBoost && data.respins[i + 1].multiplierPreWinBoost > 0) {
      let message = {};
      message.type = 'Game:boostMulti';
      message.multiSteps = data.respins[i + 1].multiplierPreWinBoost;
      this._messageQueue.push(message);
    }
  }

  this.fsWinnings += spinWin;
  this.addPopDropsOverToQueue(spinWin);

  if (this.fsCount < this.freeSpins.length) {
    this.addFSDataToQueue();
  } else {
    this.addFSEndToQueue();
    this.addGameCompleteToQueue(this.fsWinnings);
    this.inFS = false;
    this.numFsRemaining = 0;
  }

  cb();
  this.triggerNextMessage();
};

GatiServerGame.prototype.sendGambleResponseToServer = function (numScatters, response, cb) {
  if (this._gameNotFullyRecovered) {
    // no need to send state, already done and part of recovery
    this.moveToNextBetData();
    messageBus.postImmediate('Gamble:HandledCommand');
    timerManager.addTimer(500, undefined, cb);
    return;
  }

  this.resetCurrentBetData();

  let self = this;
  let decision = response === 'collect' ? 'COLLECT' : 'RISK';
  let nextStep = self._latestEngineReponse.wager.bets[self._latestEngineReponse.wager.bets.length - 1].step + 1;

  let preFix = 'GAMBLE_Basic_';
  if (this._inBuyABonus) {
    preFix = 'GAMBLE_BonusBuy_';
  } else if (this._inEncore) {
    preFix = 'GAMBLE_LuckyBet_';
  }

  // if (this._forces){

  // 	let forceJson = JSON.parse(this._forces);
  // 	//eugh, here we go
  // 	let isForceAGambleForce = forceJson[0].length === 3; // free spins cant just have 3 entries, so must be gamble
  // 	let isCollecting = decision === "COLLECT";

  // 	if (isForceAGambleForce && isCollecting){
  // 		// this scenario means the player has gone against the cheat so disgard the cheats
  // 		this._forces = undefined;
  // 	}
  // 	else if (!isCollecting && !isForceAGambleForce){
  // 		// next cheat is for free spins, but they are gambling, so needs disgarding
  // 		this._forces = undefined;
  // 	}
  // 	else{
  // 		// value force and forces setup correctly
  // 	}
  // }

  let playData = {
    cmd: preFix + decision + '_' + numScatters,
    step: nextStep,
    clientParams: '',
  };

  if (this._forces) {
    this.addCheatToRequest(playData, this._forces);
  }

  const sendCommand = async () => {
    self._latestEngineReponse = await self._slotGame.play(playData);
    self._forces = self.updateForces(self._forces);
    cb();
  };
  sendCommand();
};

GatiServerGame.prototype.addFSAwardToQueue = function (data) {
  let numFS = [7, 10, 13];
  let numScatters = data.scatterCount;

  var message = {};
  message.type = 'Game:FreeSpinsAwardEvent';
  message.freeSpinsAwarded = numFS[numScatters - 3];
  message.possibleValues = numFS;
  message.numScatters = numScatters;
  message.nextFreespins = numFS[numScatters - 2];
  message.winChance = this._gambleChances[numScatters - 3]; // reads these from game config event.
  message.buyABonus = this._inBuyABonus;
  let self = this;
  message.resultCallback = function (obj, cb) {
    self.sendGambleResponseToServer(numScatters, obj.response, cb);
  };

  this._messageQueue.push(message);
};

GatiServerGame.prototype.addGambleResultToQueue = function (won) {
  var message = {};
  message.type = 'fire_gems:GambleResultEvent';
  message.won = won;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.getSpinData = function (cb, data) {
  if (this.inFS) {
    this.getSpinDataFS(cb, data);
    return;
  }

  let parts = data.Parts;

  let totalWon = 0;
  for (let i = 0; i < parts.length; ++i) {
    let type = parts[i].type;
    this._localRngSeed = -1;

    if (type === 'baseGame') {
      this._localRngSeed = data.ResultId;
      totalWon += this.getSpinDataNormal(parts[i]);

      // base game only, game complete
      if (parts.length === 1) {
        this.addGameCompleteToQueue(totalWon);
      }
    } else if (type === 'gambleEntered') {
      if (parts[i].scatterCount >= 5) {
        // nothing to gamble for

        this.addFSAwardToQueue(parts[i]);
        this.inGamble = true;
      } else {
        this.addFSAwardToQueue(parts[i]);
        this.inGamble = true;
      }
    } else if (type === 'gambleResult') {
      let won = parts[i].hasWon;
      this.addGambleResultToQueue(won);
      if (!won) {
        this.inGamble = false;
        this.addGameCompleteToQueue(totalWon);
      }
    } else if (type === 'freeSpins') {
      this.inGamble = false;
      this.inFS = true;
      this.fsCount = 0;
      this.freeSpins = parts[i].spins;
      let numFS = [7, 10, 13];
      this.addFSStartToQueue(numFS[parts[i].scatterCount - 3]);
    }
  }

  cb();
  this.triggerNextMessage();
};

GatiServerGame.prototype.addPopsToQueue = function (winningsLinesMessage, multiplier, unMultiplied, multiplied) {
  var message = winningsLinesMessage;
  message.type = 'spinner:WinningLinesEvent';
  message.multiplier = multiplier;

  message.totalLineWinnings = multiplied; //this.gameOutcome.outcomeWinnings;
  message.totalLineWinningsNonMultiplied = unMultiplied;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.addDropsToQueue = function (serverWindow, wildCells, poppedSymbols) {
  var popWindow = [
    [0, 0, 0],
    [0, 0, 0],
    [0, 0, 0],
    [0, 0, 0],
    [0, 0, 0],
  ];

  for (let i = 0; i < poppedSymbols.length; ++i) {
    let cell = poppedSymbols[i];
    popWindow[cell.reel][cell.offset] = -1;
  }

  for (let i = 0; i < wildCells.length; ++i) {
    let wildCell = wildCells[i].coord;
    popWindow[wildCell.reel][wildCell.offset] = 0;
  }

  let newWindow = [];
  for (let i = 0; i < serverWindow.length; ++i) {
    let slot = [];
    let serverSlot = serverWindow[i].symbols;
    for (j = 0; j < serverSlot.length; ++j) {
      slot.push({ _id: serverSlot[j].value });
    }
    newWindow.push(slot);
  }

  var message = {};
  message.type = 'Game:DropEvent';
  message.tumbleData = popWindow;
  message.window = newWindow;
  message.cells = wildCells;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addModifierEventToQueue = function (data, reelListAfterPop) {
  var message = {};
  message.type = 'Game:ModifierEvent';
  message.eliminations = data.eliminations;

  for (let i = 0; i < message.eliminations.length; ++i) {
    let cell = message.eliminations[i];
    cell.offset = cell.row;
  }

  this._messageQueue.push(message);

  this.addDropsToQueue(reelListAfterPop, [], data.eliminations);
};

GatiServerGame.prototype.addPopDropsOverToQueue = function (winnings) {
  var message = {};
  message.type = 'Game:PopAndDropComplete';
  message.winnings = winnings;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSStartToQueue = function (numFs) {
  this.fsWinnings = 0;

  this.numFsRemaining = numFs;

  var message = {};
  message.type = 'Game:FreeSpinsStartEvent';
  message.freeSpinsAwarded = numFs;
  message.bonuswin = 0;
  message.currentMultiplier = 1;
  message.nextMultiplier = 2;
  this.inGamble = false;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSDataToQueue = function () {
  var message = {};
  message.type = 'Game:FreeSpinsDataEvent';
  message.num = this.numFsRemaining;
  message.fsWinnings = this.fsWinnings;
  this._messageQueue.push(message);
};
GatiServerGame.prototype.addFSEndToQueue = function () {
  var message = {};
  message.type = 'Game:FreeSpinsEndEvent';
  message.fsWinnings = this.fsWinnings + this._baseGameWinnings;
  this.fsWinnings = 0;
  this.inFS = false;
  this._messageQueue.push(message);
};
GatiServer.prototype.endGame = async function (cb) {
  this._endGame = true;
  await this.doEndGame(cb);
  this._endGame = false;
};
